<style lang="less" scoped>
.member-agreement {
  padding: 0 16px;
  background: #ffffff;
}
</style>
<template>
  <div class="member-agreement flex col" style="width:1100px;margin:0 auto;overflow-x:auto;">
    <div v-html="content"></div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('agreement')
export default {
  name: 'MemberAgreement',
  data() {
    return {
      content: ''
    }
  },
  methods: {
    ...mapActions(['loadPolicy'])
  },
  async mounted() {
    const { content } = await this.loadPolicy('privacy')
    this.content = content
  },
};
</script>


